import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../css/CookieConsentPopup.css";

import {
  COOKIE_KEY,
  saveCookieConsentLocally,
  syncCookieConsentToBackend,
} from "../utils/cookieConsent";

const CookieConsentPopup = () => {
  const [show, setShow] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  const [consent, setConsent] = useState({
    necessary: true,
    analytics: false,
    marketing: true,
    preferences: false,
  });

  useEffect(() => {
    const saved = localStorage.getItem(COOKIE_KEY);

    if (!saved) {
      setShow(true);
    }
  }, []);

  const saveConsent = async (payload) => {
    saveCookieConsentLocally(payload);
    setShow(false);

    try {
      await syncCookieConsentToBackend(payload);
    } catch (error) {
      console.error("Cookie consent backend sync failed:", error);
    }
  };

  const acceptAll = () => {
    saveConsent({
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true,
      consent_version: "v1",
    });
  };

  const rejectOptional = () => {
    saveConsent({
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false,
      consent_version: "v1",
    });
  };

  const saveCustom = () => {
    saveConsent({
      ...consent,
      necessary: true,
      consent_version: "v1",
    });
  };

  if (!show) return null;

  return (
    <div className="cookie-popup-wrap">
      <div className="cookie-popup">
        <div>
          <h6>We value your privacy</h6>

          <p>
            We use cookies and similar technologies to provide essential website
            functionality, improve your shopping experience, analyse traffic,
            and personalise content.
          </p>

          <p className="cookie-policy-links">
            By continuing, you acknowledge that you have read and understood our{" "}
            <Link to="/cookie-policy">Cookie Policy</Link>,{" "}
            <Link to="/privacy-policy">Privacy Policy</Link>, and{" "}
            <Link to="/terms-and-conditions">Terms & Conditions</Link>.
          </p>
        </div>

        {settingsOpen && (
          <div className="cookie-settings">
            <Form.Check
              id="cookie-consent-necessary"
              type="switch"
              label="Necessary cookies"
              checked
              disabled
            />

            <Form.Check
              id="cookie-consent-analytics"
              type="switch"
              label="Analytics cookies"
              checked={consent.analytics}
              onChange={(e) =>
                setConsent((prev) => ({
                  ...prev,
                  analytics: e.target.checked,
                }))
              }
            />

            <Form.Check
              id="cookie-consent-marketing"
              type="switch"
              label="Marketing cookies"
              checked={consent.marketing}
              onChange={(e) =>
                setConsent((prev) => ({
                  ...prev,
                  marketing: e.target.checked,
                }))
              }
            />

            <Form.Check
              id="cookie-consent-preferences"
              type="switch"
              label="Preference cookies"
              checked={consent.preferences}
              onChange={(e) =>
                setConsent((prev) => ({
                  ...prev,
                  preferences: e.target.checked,
                }))
              }
            />
          </div>
        )}

        <div className="cookie-footer-links">
          <Link to="/cookie-policy">Cookie Policy</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-and-conditions">Terms & Conditions</Link>
        </div>

        <div className="cookie-actions">
          <Button variant="outline-dark" size="sm" onClick={rejectOptional}>
            Reject
          </Button>

          <Button
            variant="outline-dark"
            size="sm"
            onClick={() => setSettingsOpen(!settingsOpen)}
          >
            {settingsOpen ? "Hide Options" : "Customise"}
          </Button>

          {settingsOpen ? (
            <Button variant="dark" size="sm" onClick={saveCustom}>
              Save Preferences
            </Button>
          ) : (
            <Button variant="dark" size="sm" onClick={acceptAll}>
              Accept All
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CookieConsentPopup;
